import { stripLocalePrefix } from '@/lib/i18n-utils'

const JOURNAL_PATHS = new Set([
  '/research',
  '/iot',
  '/about',
  '/what-we-do',
  '/industries',
  '/cloud-engineering',
  '/ai',
  '/data-analytics',
  '/work-with-us',
])

/** Keep the journal shell and its stylesheet on the same route boundary. */
export function isJournalPath(pathname: string): boolean {
  const path = stripLocalePrefix(pathname)
  return JOURNAL_PATHS.has(path) || path === '/blog' || path.startsWith('/blog/')
}
